module.exports = __webpack_public_path__ + "static/media/icon_login.c5c70c48.svg";